<template>
  <section class="cta d-flex justify-center align-center">
    <v-container>
      <v-row align="center">
        <v-col cols="12" sm="6">
          <div>TELAH HADIR MUSEUM KOLEKSI SONGKET TERBAIK</div>
        </v-col>
        <v-col class="text-sm-right" cols="12" sm="6">
          <!-- <div class="line-button-cta"> -->
            <!-- <div> -->
              <!-- <span class="text-caption white--text">Lorem ipsum</span> -->
            <!-- </div> -->
          <!-- </div> -->
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
